// @flow strict

import React, { type Node } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * LinkedIn icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const LinkedinIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H34.858V34.983H0z" />
      <path
        className="linkedin"
        fill={color}
        d="M10.4 15.099h3.088V25.9H10.4V15.1zm1.465-1.351h-.022c-1.118 0-1.843-.826-1.843-1.872C10 10.81 10.746 10 11.886 10s1.84.807 1.863 1.873c0 1.046-.723 1.875-1.884 1.875zM25.845 25.9h-3.502v-5.59c0-1.463-.548-2.461-1.753-2.461-.921 0-1.433.673-1.672 1.323-.09.233-.075.557-.075.883v5.845h-3.47s.045-9.902 0-10.802h3.47v1.695c.205-.741 1.313-1.799 3.082-1.799 2.195 0 3.92 1.555 3.92 4.9V25.9z"
      />
    </g>
  );
};
